import { useState } from 'react';
import { Link } from 'react-router-dom'
import headshot from './images/oneeb_header_pic.jpg'



const Home = () => {

	return ( 
		<div className="container-fluid">
		<div className="home">
			<p className="name">Muhammad Oneeb Ul Haq Khan</p>
			<div>
				<img src={headshot} className="headshot" alt=""/>
				{/* <p className="bio">It is not the critic who counts; not the man who points out how the strong man stumbles, or where the doer of deeds could have done them better. The credit belongs to the man who is actually in the arena, whose face is marred by dust and sweat and blood; who strives valiantly; who errs, who comes short again and again, because there is no effort without error and shortcoming; but who does actually strive to do the deeds; who knows great enthusiasms, the great devotions; who spends himself in a worthy cause; who at the best knows in the end the triumph of high achievement, and who at the worst, if he fails, at least fails while daring greatly, so that his place shall never be with those cold and timid souls who neither know victory nor defeat.</p>
				<p>- Theodore Roosevelt</p> */}
				<p className="bio">
					I am currently working as a Data Engineer at <a href="https://www.din.global" 
					target="_blank">DGlobal</a>, where I spend my time designing and implementing our Data 
					infrastructure as part of our Core Banking platform while leading a (growing) team of 3.
				</p>

				<p className="bio">
					I had a brief stint as a Data Engineer at the once poster child and now defunct startup <a 
					href="https://techcrunch.com/2022/07/12/airlift-shutdown/" target="_blank">Airlift</a>.
				</p>

				<p className="bio">
					I completed my Master’s in Computer Science at the University of Southern California in December 
					2021, where my course work focused on Machine Learning and Artificial Intelligence. 
					While at USC, I worked as a Graduate Machine Learning Researcher on implementing Boosting 
					approaches with an existing Federated Machine Learning framework with <a 
					href="https://www.isi.edu/~ambite/" target="_blank">Prof. Jose-Luise Ambite</a> and <a 
					href="https://www.linkedin.com/in/dstripelis/" target="_blank">Dimitris Stripelis</a> at USC's <a 
					href="https://www.isi.edu/" target="_blank">Information Sciences Institute</a>. I also worked on 
					developing an RL agent to learn <a href="https://raghavan.usc.edu/papers/agroecology-chi16.pdf" 
					target="_blank">sustainable agroecological practices</a> with <a href="https://raghavan.usc.edu/" 
					target="_blank">Prof. Barath Raghavan</a> and <a href="" target="_blank">Adam Streed</a>.
				</p>

				<p className="bio"> 
					As an enthusiastic computer scientist and engineer, I am curious about technology's role in 
					society. I want to understand what kind of solutions we can expect by incorporating 
					technology in some of our biggest problems (e.g. equity, justice, hunger, climate change, 
					security), what are the constraints and limitations, what kind of problems have societal/cultural 
					solutions rather than technological ones, and how can we harness both, technology and 
					society, together. For these reasons, I am actively seeking out answers to the following 
					questions, particularly in the Pakistani context:
				</p>

				<ul className="bio">
					<li className="bio">What role can technology play and what level of impact can it generate?</li>
					<li className="bio">What kind of societal challenges lie with big waves of technological
						 disruption that need to be proactively addressed?</li>
					<li className="bio">How can Pakistan best ready itself for the era of data supremacy and AI, and 
					what policy roadmaps should be in place?</li>
				</ul>
				
				<p className="bio">
					If these are questions that interest you as well, consider <Link to='/contact'>reaching out</Link>.
				</p>

				<p className="bio">
					I am also interested in the intersection of High Performance Computing and Physics, and look 
					forward to better understanding and exploring this in future projects or collaborations.
				</p>

				<p className="bio">
					If I am not busy with work, other side projects or coursework, I might be:
						<ul className="bio">
							<li className="bio"><Link to='/running'>running</Link></li>
							<li className="bio"><a href="https://nust.edu.pk/news/seecs-class-of-2017-establishes-scholarship-fund-as-a-class-gift-under-need-initiative/" 
							target="_blank">organizing the SEECS 2017 scholarship fund for deserving students at NUST</a>
							</li>
							<li className="bio">managing a farm</li>
						</ul>
				</p>
				{/* NEED TO MENTION THOUGHTS ON AI and Data Policy Roadmap */}
			</div>
		</div>
		</div>
	 );

}
 
export default Home;